import { FormField } from "components/Forms/FormField";
import { generateGuid } from "helpers";
import React, { RefObject, useMemo, useRef } from "react";

import { defaultSize } from "./LyneConstants";
import { LyneFormField } from "./LyneFormField";
import { LyneInputReset } from "./LyneInputReset";

export interface LyneInputProps extends FormField {
  value?: string;
  onChange: (value: string) => void;
  maxLength?: number;
  minLength?: number;
  placeholder?: string;
  size?: "s" | "m" | "l";
  style?: React.CSSProperties;
  forwardRef?: RefObject<HTMLInputElement | null>;
}

export const LyneInput: React.FC<LyneInputProps> = ({
  name,
  disabled,
  value = "", // prevents uncontrolled to controlled component warning.
  onChange,
  maxLength,
  minLength,
  placeholder,
  size = defaultSize,
  forwardRef,
  style,
  required,
  label,
  contextHelp,
}) => {
  const nameToUse = useMemo(() => name || generateGuid(), [name]);

  const fallbackRef = useRef<HTMLInputElement>(null);
  const ref = useMemo(() => {
    return forwardRef || fallbackRef;
  }, [forwardRef, fallbackRef]);

  return (
    <LyneFormField size={size} name={nameToUse} required={required} label={label} contextHelp={contextHelp}>
      <input
        type="text"
        required={required}
        name={nameToUse}
        ref={ref}
        value={value}
        maxLength={maxLength}
        minLength={minLength}
        placeholder={placeholder}
        disabled={disabled}
        onFocus={(e) => {
          e.target.select();
        }}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        style={style}
      />

      <LyneInputReset
        onClick={() => {
          if (value) onChange("");
          ref?.current?.focus();
        }}
        disabled={!value}
      />
    </LyneFormField>
  );
};
